import gql from 'graphql-tag';

export const channelsByModuleCategoriesQuery = gql`
  query channelsByModuleCategories(
    $moduleCategories: [ModuleCategoryEnum!]!
    $pagination: PaginationInput!
  ) {
    me {
      channelsByModuleCategories(
        moduleCategories: $moduleCategories
        pagination: $pagination
      ) {
        channels {
          _id
          name
          profile {
            image
            logo
          }
          address {
            street1
            city
            state
            code
          }
        }
        pageInfo {
          start
          total
          perPage
        }
      }
    }
  }
`;
